import React from 'react';
import { observer } from 'mobx-react-lite';
import useFilteredResults from '@unmapped/core/hooks/useFilteredResults';
import useStyleOverride from "../../../hooks/useStyleOverride.js";
import { decorateName } from '@unmapped/core/utils';
import baseStyles from "./styles.module.css.js";
export var OverlayHeaderText = decorateName(observer(_ref => {
  var {
    children
  } = _ref;
  var filteredResults = useFilteredResults();
  var styles = useStyleOverride('layouts/TwoColumnOverlayMap/OverlayHeaderText', baseStyles);
  if (children) {
    if (typeof children === 'string') {
      return /*#__PURE__*/React.createElement("h2", {
        className: styles.OverlayHeaderText
      }, "showing ", filteredResults.length, " results");
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.OverlayHeaderText
      }, children);
    }
  } else {
    return /*#__PURE__*/React.createElement("h2", {
      className: styles.OverlayHeaderText
    }, "showing ", filteredResults.length, " results");
  }
}), 'OverlayHeaderText');
export default OverlayHeaderText;
//# sourceMappingURL=index.js.map